import React from 'react';

const HighIntentLeadsSVG = ({
  color = 'black',
  className,
  onClick,
  ...props
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='32'
      height='17'
      viewBox='0 0 32 17'
      fill='none'
      className={className}
    >
      <path
        d='M1 15.1667L9.33352 6.83331'
        stroke='#0744E1'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.9987 6.83334C11.9192 6.83334 12.6654 6.08715 12.6654 5.16667C12.6654 4.24619 11.9192 3.5 10.9987 3.5C10.0782 3.5 9.33203 4.24619 9.33203 5.16667C9.33203 6.08715 10.0782 6.83334 10.9987 6.83334Z'
        fill='#0744E1'
        stroke='#0744E1'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M19.3308 15.1667C20.2513 15.1667 20.9975 14.4205 20.9975 13.5C20.9975 12.5795 20.2513 11.8333 19.3308 11.8333C18.4103 11.8333 17.6641 12.5795 17.6641 13.5C17.6641 14.4205 18.4103 15.1667 19.3308 15.1667Z'
        fill='#0744E1'
        stroke='#0744E1'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12.668 6.83332L17.6681 11.8333M21.0015 11.8333L31.0017 1.83331'
        stroke='#0744E1'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default HighIntentLeadsSVG;
